import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { FEATURE_NAMES } from '../model/constants/features';
import { FeatureToggleService } from '../service/feature-toggle/feature-toggle.service';
import { IQuery } from './navigation-query/IQuery';
import { QueryGenerator } from './query-generator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ansokan-home',
  styleUrls: ['./ansokan-home.component.scss'],
  templateUrl: './ansokan-home.component.html',
  standalone: false,
})
export class AnsokanHomeComponent implements OnInit {
  private static readonly LOCAL_FEATURE_TIMEOUT_MS = 3000;
  private generator: QueryGenerator;

  // Here we create the query object once.
  // This gives us the same object reference during each change detection,
  // instead of creating a new object every time the template is read.
  public query: IQuery | null = null;

  constructor(private service: FeatureToggleService) {}

  // public ngOnInit() {
  //   this.getFeatureTogglesWithLocalFallback(
  //     FEATURE_NAMES.USE_NEW_LLEG_DIGITAL_APPLICATION,
  //     FEATURE_NAMES.USE_NEW_LLEG_PAPER_APPLICATION,
  //   ).subscribe((features) =>
  //     this.generator = new QueryGenerator(
  //       features[FEATURE_NAMES.USE_NEW_LLEG_DIGITAL_APPLICATION],
  //       features[FEATURE_NAMES.USE_NEW_LLEG_PAPER_APPLICATION],
  //     ),
  //   );
  // }

  public ngOnInit(): void {
    this.getFeatureTogglesWithLocalFallback(
      FEATURE_NAMES.USE_NEW_LLEG_DIGITAL_APPLICATION,
      FEATURE_NAMES.USE_NEW_LLEG_PAPER_APPLICATION,
    ).subscribe((features) => {
      this.generator = new QueryGenerator(
        features[FEATURE_NAMES.USE_NEW_LLEG_DIGITAL_APPLICATION],
        features[FEATURE_NAMES.USE_NEW_LLEG_PAPER_APPLICATION],
      );

      //create query  structure   only once when feature toggles  are downloaded.
      // we should newer do this as  before thru  geter in template  becouse   getQuery()
      // creates a new object  each time  and that  causes  change detection to run  every time.
      this.query = this.generator.getQuery();
    });
  }

  private getFeatureTogglesWithLocalFallback(
    ...featureNames: string[]
  ): Observable<{ [name: string]: boolean }> {
    // Vi väntar först på feature toggles från backend.
    // Om inget svar kommer i lokal miljö sätter vi toggles till false.
    // Då visas frågedata från QueryGenerator i stället för från backend.
    return this.service.getFeatureToggles(...featureNames).pipe(
      timeout(AnsokanHomeComponent.LOCAL_FEATURE_TIMEOUT_MS),
      catchError(() => {
        if (environment.production) {
          return of({});
        }

        return of(
          featureNames.reduce(
            (result: { [name: string]: boolean }, featureName: string) => {
              result[featureName] = false;
              return result;
            },
            {},
          ),
        );
      }),
    );
  }
}
